import { createSlice } from "@reduxjs/toolkit";

const DEFAULT_FACILITY_ACCESS = {
  read: true,
  write: true,
};

// initial state
const initialState = {
  role: null,
  facilityAccess: DEFAULT_FACILITY_ACCESS,
  isMultipleFacility: false,
  facilityIds: [],
  // Merged from permissions.js - user's permission list
  userPermissions: ["DELETE"],
};

// ==============================|| SLICE - PERMISSION ||============================== //

const permissionSlice = createSlice({
  name: "permission",
  initialState,
  reducers: {
    setFacilityAccess(state, action) {
      state.facilityAccess = action.payload;
    },
    setRoleName(state, action) {
      state.role = action.payload;
    },
    setFacilityIds(state, action) {
      state.facilityIds = action.payload;
    },
    setMultipleFacility(state, action) {
      state.isMultipleFacility = action.payload;
    },
    // Merged from permissions.js
    setUserPermissions(state, action) {
      state.userPermissions = action.payload;
    },
  },
});

export default permissionSlice.reducer;

export const {
  setRoleName,
  setFacilityAccess,
  setMultipleFacility,
  setFacilityIds,
  setUserPermissions,
} = permissionSlice.actions;

// Legacy action type constants for backward compatibility
export const PERMISSION_ACTION_TYPES = {
  SET_PERMISSIONS: "permission/setUserPermissions",
};
